import { addYears } from 'date-fns';

import { formatDateToLocalInput } from './formatDateToLocalInput';

export const getApiKeyDefaultExpiresAt = (): string =>
  formatDateToLocalInput(addYears(new Date(), 1));
